export const PEOPLE_REQUEST = "peopleReducer/PEOPLE_REQUEST";
export const PEOPLE_SUCCESS = "peopleReducer/PEOPLE_SUCCESS";
export const PEOPLE_FAILED = "peopleReducer/PEOPLE_FAILED";
export const PEOPLE_RESET = "peopleReducer/PEOPLE_RESET";

export const PEOPLE_CHANGE = "peopleReducer/PEOPLE_CHANGE";

export const PEOPLE_SEARCH = "peopleReducer/PEOPLE_SEARCH";

export const PEOPLE_SEARCH_RESET = "peopleReducer/PEOPLE_SEARCH_RESET";

export const INVITE_STUDENT_REQUEST = "inviteStudentReducer/INVITE_STUDENT_REQUEST";
export const INVITE_STUDENT_SUCCESS = "inviteStudentReducer/INVITE_STUDENT_SUCCESS";
export const INVITE_STUDENT_FAILED = "inviteStudentReducer/INVITE_STUDENT_FAILED";
export const INVITE_STUDENT_RESET = "peopleReducer/INVITE_STUDENT_RESET";



export const DELETE_STUDENT_REQUEST = "deleteStudentReducer/DELETE_STUDENT_REQUEST";
export const DELETE_STUDENT_SUCCESS = "deleteStudentReducer/DELETE_STUDENT_SUCCESS";
export const DELETE_STUDENT_FAILED = "deleteStudentReducer/DELETE_STUDENT_FAILED";
export const DELETE_STUDENT_RESET = "peopleReducer/DELETE_STUDENT_RESET";

